import ScheduleIcon from "@material-ui/icons/Schedule";
import { IRoute } from "src/common/typings/routes";
import { SchedulingList } from "./pages/ListOfScheduling";
import { SchedulingModule } from "./schedulingModule";

export const SchedulingRoute: IRoute = {
  title: "Scheduling",
  path: "/scheduling",
  icon: ScheduleIcon,
  component: SchedulingModule,
  subRoutes: [
    {
      component: SchedulingList,
      path: "/list-scheduling",
      title: "List of Scheduling",
    },
    // {
    //   component: WODetails,
    //   path: "/work-order-details",
    //   pathParam: "/:id/:ordNum",
    //   title: "Work Order Details",
    //   noDrawer: true,
    // },
  ],
};
